import { Navigate } from 'react-router-dom';
import { useSiteFeatureFlags } from '../../hooks/useSiteFeatureFlags';

/**
 * Wraps every transfer route. With the feature flag off the route behaves as if
 * it does not exist (same redirect the catch-all gives any unknown URL). The
 * backend independently 404s the API, so this is presentation, not access control.
 */
const TransferGate = ({ children, flag = 'transfer_enabled' }) => {
  const flags = useSiteFeatureFlags();
  if (!flags._loaded) return null;
  return flags[flag] ? children : <Navigate to="/" replace />;
};

export default TransferGate;
